import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {TabletCalVW} from "@utils/CalVW.tsx";

export const ProfileSettingContainerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1200px;
  height: 100%;
  margin-top: 30px;
    
    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }
    
`;
